/**
 * AlmadarPostAgenticSearchENAlmadarPostAgenticSearchENPage
 *
 * Page component for AlmadarPostAgenticSearchENAlmadarPostAgenticSearchENPage
 * Path: /blog/agentic-search
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostAgenticSearchENPostPageView as __AlmadarPostAgenticSearchENPostPageView } from '@/components/traits/AlmadarPostAgenticSearchENPostPageView';
import { AlmadarPostAgenticSearchENPostAnalyticsView as __AlmadarPostAgenticSearchENPostAnalyticsView } from '@/components/traits/AlmadarPostAgenticSearchENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostAgenticSearchENAlmadarPostAgenticSearchENPageProps {
  // Add any page-level props here
}

export function AlmadarPostAgenticSearchENAlmadarPostAgenticSearchENPage(_props: AlmadarPostAgenticSearchENAlmadarPostAgenticSearchENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostAgenticSearchENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostAgenticSearchENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostAgenticSearchENAlmadarPostAgenticSearchENPage;
